import React from 'react';
import PropTypes from 'prop-types';
import momentPropTypes from 'react-moment-proptypes';

import DayMonthPicker, { displayDayMonth } from '../input/DayMonthPicker';
import EditableToggle from './EditableToggle';
import nullable from '../../utils/nullable';

const EditableDayMonthPicker = ({
  onChange,
  value,
  submitOnBlur = true,
  readOnly = false,
  displayValue = null,
  required = false,
  ...rest
}) => (
  <EditableToggle
    onSubmit={onChange}
    value={value}
    readOnly={readOnly}
    required={required}
    displayValue={displayValue || (!!value && displayDayMonth(value))}
  >
    {({ inputValue, setInputValue, inputRef, submit, cancel, handleKeyDown }) => (
      <DayMonthPicker
        value={inputValue}
        onChange={setInputValue}
        onBlur={submitOnBlur ? submit : cancel}
        onKeyDown={e => {
          // Submit or cancel when pressing the tab key on the month control or shift tab on the day control
          if (
            e.keyCode === 9 &&
            ((e.target.name === 'month' && !e.shiftKey) || (e.target.name === 'day' && e.shiftKey))
          ) {
            setTimeout(() => {
              if (submitOnBlur) submit();
              else cancel();
            }, 100);
            return;
          }
          handleKeyDown(e);
        }}
        inputRef={inputRef}
        {...rest}
      />
    )}
  </EditableToggle>
);

EditableDayMonthPicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: nullable(
    PropTypes.oneOfType([
      PropTypes.instanceOf(Date),
      momentPropTypes.momentObj,
      PropTypes.shape({ day: PropTypes.number, month: PropTypes.number }),
    ]),
  ).isRequired,
  readOnly: PropTypes.bool,
  displayValue: PropTypes.node,
  submitOnBlur: PropTypes.bool,
  required: PropTypes.bool,
};

export default EditableDayMonthPicker;
